import type { ConversationMessage } from "../types";
import type { ReactionId } from "./emotionCatalog";

const EMOTION_KEY = "quanty.emotions";
const HISTORY_KEY = "quanty.history";

export function loadSeenEmotions(): ReactionId[] {
  if (typeof window === "undefined") {
    return [];
  }
  try {
    const raw = localStorage.getItem(EMOTION_KEY);
    return raw ? (JSON.parse(raw) as ReactionId[]) : [];
  } catch (error) {
    console.warn("Failed to load emotion cache", error);
    return [];
  }
}

export function persistSeenEmotions(emotions: ReactionId[]): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    localStorage.setItem(EMOTION_KEY, JSON.stringify(emotions));
  } catch (error) {
    console.warn("Failed to persist emotion cache", error);
  }
}

export function loadHistory(): ConversationMessage[] {
  if (typeof window === "undefined") {
    return [];
  }
  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    return raw ? (JSON.parse(raw) as ConversationMessage[]) : [];
  } catch (error) {
    return [];
  }
}

export function persistHistory(history: ConversationMessage[]): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
  } catch (error) {
    console.warn("Failed to persist history", error);
  }
}

export function clearStorage(): void {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.removeItem(EMOTION_KEY);
  localStorage.removeItem(HISTORY_KEY);
}
